export class Address {
  constructor(
    public addressLine1 = '',
    public addressLine2 = '',
    public city = '',
    public state = '',
    public zipCode = '') {
  }

  loadFrom(options: any) {
    this.addressLine1 = options.addressLine1;
    this.addressLine2 = options.addressLine2;
    this.city = options.city;
    this.state = options.state;
    this.zipCode = options.zipCode;
  }

  clear() {
    this.addressLine1 = '';
    this.addressLine2 = '';
    this.city = '';
    this.state = '';
    this.zipCode = '';
  }
}
